var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9 14.81C10 14.97 10.06 15.16 10.06 15.35C10.06 15.6 9.96 15.84 9.78 16.02C9.6 16.2 9.36 16.3 9.11 16.3C8.92 16.3 8.74 16.24 8.58 16.14C8.42 16.03 8.3 15.88 8.23 15.71C8.15 15.54 8.13 15.34 8.17 15.16C8.21 14.97 8.3 14.81 8.43 14.67C8.57 14.54 8.74 14.45 8.92 14.41C9.11 14.38 9.3 14.39 9.47 14.46C9.65 14.53 9.79 14.66 9.9 14.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.57 14.81C16.67 14.97 16.73 15.16 16.73 15.35C16.73 15.6 16.63 15.84 16.45 16.02C16.27 16.2 16.03 16.3 15.78 16.3C15.59 16.3 15.41 16.24 15.25 16.14C15.09 16.03 14.97 15.88 14.9 15.71C14.82 15.54 14.81 15.34 14.84 15.16C14.88 14.97 14.97 14.81 15.1 14.67C15.24 14.54 15.41 14.45 15.59 14.41C15.78 14.38 15.97 14.39 16.15 14.46C16.32 14.53 16.46 14.66 16.57 14.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.06 7.72L17.51 11.06H14.35V7.72H15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM19.11 15.35C19.11 15.47 19.06 15.6 18.97 15.68C18.89 15.77 18.76 15.82 18.64 15.82H17.62C17.51 16.22 17.27 16.58 16.93 16.83C16.6 17.09 16.2 17.23 15.78 17.23C15.36 17.23 14.95 17.09 14.62 16.83C14.29 16.58 14.05 16.22 13.94 15.82H10.95C10.83 16.22 10.6 16.58 10.26 16.83C9.93 17.09 9.52 17.23 9.11 17.23C8.7 17.23 8.28 17.09 7.95 16.83C7.62 16.58 7.38 16.22 7.27 15.82H6.25C6.12 15.82 6 15.77 5.91 15.68C5.82 15.6 5.77 15.47 5.77 15.35V7.25C5.77 7.12 5.82 7 5.91 6.91C6 6.82 6.12 6.77 6.25 6.77H15.3C15.38 6.77 15.45 6.79 15.52 6.83C15.59 6.86 15.64 6.91 15.69 6.98L19.02 11.53C19.08 11.61 19.11 11.71 19.11 11.8V15.35Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipVehicle);
export default __webpack_public_path__ + "static/media/ic-chip-vehicle.59632e001118c62f3861b6e992401746.svg";
export { ForwardRef as ReactComponent };